import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import mainApi from "../../../assets/api/MainApi";
import { ArrowIcon } from "../../../assets/icons/icons";
import MiniPreloader from "../../MiniPreloader/MiniPreloader";

import "./CatalogDrop.css";
import { CATALOG_MAIN_LINK, IMG_PLACEHOLDER_PRODUCT } from "../../../assets/utils/constants";
import { ConfigContext } from "../../../assets/contexts/configContext";
import { getCorrectGoodsWordForm } from "../../../assets/utils/utils";

function CatalogDrop({ isOpened, setOpened, categories, catalogBtnRef }) {
  const dorpRef = useRef();
  const navigate = useNavigate();

  const config = useContext(ConfigContext);
  const { initialConstants } = config;
  const { SHOP_ID_FOR_API } = initialConstants;

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu

      if (isOpened && dorpRef.current && !dorpRef.current.contains(e.target)) {
        setOpened(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isOpened]);

  useEffect(() => {
    // catalogBtnRef.current.onclick = null;
    if (isOpened) {
      catalogBtnRef.current.onclick = () => {
        setOpened(false);
      };
    } else {
      setTimeout(() => {
        catalogBtnRef.current.onclick = () => {
          setOpened(true);
        };
      }, 300);
    }
  }, [isOpened]);

  const [selectedCategory, setSelectCategory] = useState(undefined);
  const [isPreloaderVisible, setPreloaderVisible] = useState(false);
  const [subcategories, setSubcategories] = useState(undefined);
  const [subcategoriesCache, setSubcategoriesCache] = useState({});
  const requestIdRef = useRef(0);
  const getCategoryImage = (category) => {
    if (!category) return null;
    return category.file ? category.file.urls.orig : IMG_PLACEHOLDER_PRODUCT;
  };

  function closeDropdown() {
    setOpened(false);
    setTimeout(() => {
      setOpened(false);
    }, 1);
  }

  function loadCategory(item, { skipRedirect = false } = {}) {
    if (!item) return;

    const currentRequestId = ++requestIdRef.current;
    setSelectCategory(item);
    setSubcategories(undefined);

    if (item.is_final) {
      setSubcategories([]);
      setPreloaderVisible(false);

      if (!skipRedirect) {
        navigate(`/${CATALOG_MAIN_LINK}/${item.translit_name}`);
        closeDropdown();
      }
      return;
    }

    if (subcategoriesCache[item._id]) {
      setSubcategories(subcategoriesCache[item._id]);
      setPreloaderVisible(false);
      return;
    }

    setPreloaderVisible(true);

    mainApi
      .getCategories({
        limit: 25,
        shop_id: SHOP_ID_FOR_API,
        _id: item._id,
      })
      .then((res) => {
        if (currentRequestId !== requestIdRef.current) return;
        setSubcategories(res.data);
        setSubcategoriesCache((prev) => ({ ...prev, [item._id]: res.data }));

        if (!skipRedirect && res.data.length === 0) {
          navigate(`/${CATALOG_MAIN_LINK}/${item.translit_name}`);
          closeDropdown();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        if (currentRequestId === requestIdRef.current) {
          setPreloaderVisible(false);
        }
      });
  }

  function handleSelectCategory(item) {
    const isAlreadySelected =
      selectedCategory && selectedCategory._id === item._id;

    if (isAlreadySelected && !isPreloaderVisible) {
      navigate(`/${CATALOG_MAIN_LINK}/${item.translit_name}`);
      closeDropdown();
      return;
    }

    loadCategory(item);
  }

  function handlePreviewCategory(item) {
    const isAlreadySelected =
      selectedCategory && selectedCategory._id === item._id;
    if (isAlreadySelected) return;
    loadCategory(item, { skipRedirect: true });
  }

  useEffect(() => {
    if (!isOpened || selectedCategory || !categories || categories.length === 0)
      return;
    loadCategory(categories[0], { skipRedirect: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpened, categories]);

  useEffect(() => {
    if (!isOpened) {
      requestIdRef.current += 1;
    }
  }, [isOpened]);

  useEffect(() => {
    if (!isOpened || !categories || categories.length === 0) return;

    const handleArrows = (e) => {
      if (!["ArrowDown", "ArrowUp", "ArrowRight"].includes(e.key)) return;
      e.preventDefault();
      const currentIndex = categories.findIndex(
        (c) => selectedCategory && c._id === selectedCategory._id
      );
      if (e.key === "ArrowDown") {
        const nextIndex =
          currentIndex === -1
            ? 0
            : Math.min(categories.length - 1, currentIndex + 1);
        loadCategory(categories[nextIndex], { skipRedirect: true });
      }
      if (e.key === "ArrowUp") {
        const prevIndex =
          currentIndex <= 0 ? 0 : Math.max(0, currentIndex - 1);
        loadCategory(categories[prevIndex], { skipRedirect: true });
      }
      if (e.key === "ArrowRight" && selectedCategory) {
        navigate(`/${CATALOG_MAIN_LINK}/${selectedCategory.translit_name}`);
        closeDropdown();
      }
    };

    document.addEventListener("keydown", handleArrows);
    return () => document.removeEventListener("keydown", handleArrows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpened, categories, selectedCategory]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") closeDropdown();
    };
    if (isOpened) {
      document.addEventListener("keydown", handleEsc);
    }
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpened]);


  // useEffect(() => {
  //   if (!categories) return
  //   const filteredCategories = categories ? categories.filter((item) => item.type) : undefined
  //   let item = filteredCategories[0]
  //   setSelectCategory(item)
  //   setPreloaderVisible(true)
  //   mainApi.getSubcategoriesByCategory({
  //     category_translit_name: item.translit_name,
  //     limit: 25,
  //   })
  //     .then((res2) => {
  //       console.log(res2.data)
  //       setSubcategories(res2.data)
  //       // setSelectedCategory(res2.category)
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  //     .finally(() => {
  //       setPreloaderVisible(false)
  //     })
  // }, [categories])

  return (
    <>
      {categories && categories.length > 0 && Array.isArray(categories) ? (
        <div
          className={`catalog-drop__container ${isOpened ? "catalog-drop__container_active" : ""
            }`}
          onClick={(e) => {
            if (e.target.classList.contains("catalog-drop__container")) closeDropdown();
          }}
        >
          <div
            ref={dorpRef}
            className={`catalog-drop ${isOpened ? "catalog-drop_active" : "catalog-drop_inactive"
              }`}
          >
            <div className="catalog-drop__content">
              <div className="catalog-drop__headline">
                <div className="catalog-drop__headline-text">
                  <p className="catalog-drop__eyebrow">Каталог</p>
                  {/* <h3 className="catalog-drop__title">Быстрый выбор раздела</h3> */}
                  <p className="catalog-drop__subtitle">
                    Найдите нужный раздел и переходите к покупкам.
                  </p>
                </div>
                <Link
                  className="catalog-drop__all"
                  to={`/${CATALOG_MAIN_LINK}`}
                  onClick={closeDropdown}
                >
                  Весь каталог
                </Link>
              </div>

              <div className="catalog-drop__grid">
                <div className="catalog-drop__categories">
                  {categories.map((item, i) => (
                    <button
                      className={`catalog-drop__card ${selectedCategory && selectedCategory._id === item._id
                        ? "catalog-drop__card_selected"
                        : ""
                        }`}
                      key={`catalog-drop__card${i}${item._id}`}
                      type="button"
                      onClick={() => {
                        handleSelectCategory(item);
                      }}
                      onMouseEnter={() => handlePreviewCategory(item)}
                    >
                      <div className="catalog-drop__card-info">
                        <p className="catalog-drop__card-name">{item.name}</p>
                        {item.count ? (
                          <span className="catalog-drop__card-count">
                            {item.count} {getCorrectGoodsWordForm(item.count)}
                          </span>
                        ) : null}
                      </div>
                      {!item.is_final ? (
                        <ArrowIcon
                          mainClassName={"catalog-drop__card-arrow"}
                          fillClassName={"catalog-drop__card-arrow-fill"}
                        />
                      ) : null}
                    </button>
                  ))}
                </div>

                <div className="catalog-drop__subcategories-shell">
                  <div className="catalog-drop__subheader">
                    <div>
                      {/* <p className="catalog-drop__eyebrow catalog-drop__eyebrow_muted">
                        {selectedCategory ? "Внутри раздела" : "Раздел"}
                      </p> */}
                      <h4 className="catalog-drop__subheader-title">
                        {selectedCategory
                          ? selectedCategory.name
                          : "Выберите категорию"}
                      </h4>
                    </div>
                    {selectedCategory ? (
                      <Link
                        className="catalog-drop__cta"
                        to={`/${CATALOG_MAIN_LINK}/${selectedCategory.translit_name}`}
                        onClick={closeDropdown}
                      >
                        Перейти к товарам
                      </Link>
                    ) : null}
                  </div>

                  {isPreloaderVisible ? (
                    <div className="catalog-drop__preloader">
                      <MiniPreloader />
                    </div>
                  ) : (
                    <>
                      {subcategories && subcategories.length > 0 ? (
                        <div className="catalog-drop__subcategories">
                          {subcategories.map((item, i) => (
                            <Link
                              key={`catalog-drop__subcategory${i}${item._id}`}
                              className="catalog-drop__subcategory"
                              to={`/${CATALOG_MAIN_LINK}/${selectedCategory.translit_name}/${item.translit_name}`}
                              onClick={closeDropdown}
                            >
                              {item.name}
                            </Link>
                          ))}
                        </div>
                      ) :
                        (
                          <div className="catalog-drop__empty">
                            {selectedCategory && getCategoryImage(selectedCategory) ? (
                              <Link
                                className="catalog-drop__empty-link"
                                to={`/${CATALOG_MAIN_LINK}/${selectedCategory.translit_name}`}
                                onClick={closeDropdown}
                              >
                                <img
                                  className="catalog-drop__empty-image"
                                  src={getCategoryImage(selectedCategory)}
                                  alt={selectedCategory.name}
                                />
                              </Link>
                            ) : null}
                          </div>
                        )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className={`catalog-drop__background ${isOpened ? 'catalog-drop__background_active' : ''}`} onClick={closeDropdown}></div> */}
        </div>
      ) : null}
    </>
  );
}

export default CatalogDrop;
